import { gql } from '@apollo/client'

import { magazineIssueListFragment } from 'js/magazine-issue/fragments/MagazineIssueList.fragment'

export const MAGAZINE_ISSUES_LIST = gql`
    query MagazineIssuesList(
        $parentGuid: String
        $offset: Int
        $limit: Int
        $subtypes: [String]
        $orderBy: OrderBy
        $orderDirection: OrderDirection
    ) {
        entities(
            parentGuid: $parentGuid
            offset: $offset
            limit: $limit
            subtypes: $subtypes
            orderBy: $orderBy
            orderDirection: $orderDirection
        ) {
            total
            edges {
                guid
                ...MagazineIssueList
            }
        }
    }
    ${magazineIssueListFragment}
`
